import { Component, OnDestroy } from '@angular/core';
import * as fromRoot from '@app/reducers';
import { DialogRef } from '@ngneat/dialog';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { GroupsActions } from '../../actions';
import * as fromGroups from '../../reducers/groups.reducer';

@Component({
  selector: 'app-modal-delete-group',
  templateUrl: './modal-delete-group.component.html',
  styleUrls: ['./modal-delete-group.component.scss']
})
export class ModalDeleteGroupComponent implements OnDestroy {
  deleteGroupPending$: Observable<boolean>;
  deleteGroupSuccess$: Observable<boolean>;
  deleteGroupError$: Observable<any>;

  submitted = false;
  subscriptions: Subscription[] = [];
  teamId: string;

  constructor(private store$: Store<fromRoot.State & fromGroups.State>, public ref: DialogRef) {
    this.teamId = this.ref.data.teamId;
    this.deleteGroupPending$ = this.store$.select(fromGroups.getDeleteGroupPending);
    this.deleteGroupSuccess$ = this.store$.select(fromGroups.getDeleteGroupSuccess);
    this.deleteGroupError$ = this.store$.select(fromGroups.getDeleteGroupError);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  deleteGroup() {
    this.store$.dispatch(GroupsActions.DeleteGroup({ teamId: this.teamId, groupId: this.ref.data.group.id }));
    this.subscriptions.push(
      this.deleteGroupSuccess$.subscribe(res => {
        if (res) {
          this.store$.dispatch(GroupsActions.LoadGroups({ teamId: this.teamId }));
          this.close();
        }
      })
    );
  }

  close() {
    this.ref.close();
  }
}
